import { z } from 'zod';
import { phoneNumberField } from '@shared/schemas';
import { Languages } from '../constants/languages';
import { projectSchema } from './IProject';
import { userPermissionsSchema } from './IUserPermissions';
import { userPreferencesSchema } from './IUserPreferences';
// Schemas (source of truth)
export const userSchema = z.object({
	_id: z.string().optional(),
	name: z.string(),
	email: z.email(),
	password: z.string().nullable().optional(),
	permissions: userPermissionsSchema,
	phoneNumber: phoneNumberField,
	organizationIds: z.array(z.string()).default([]),
	projectIds: z.array(z.string()).default([]),
	username: z.string(),
	// Monotonic revocation counter. Missing on legacy users → treated as 0.
	// Bumped by Entities on password set/reset/update and on deactivation.
	tokenVersion: z.number().int().nonnegative().optional(),
	// Deactivation flag. Missing on legacy users → treated as active (true).
	isActive: z.boolean().optional(),
});

export const loggedUserSchema = z.object({
	accessToken: z.string(),
	refreshToken: z.string(),
	userDetails: userSchema,
	userProjects: z.array(projectSchema),
	userPreferences: userPreferencesSchema.nullable().optional(),
});

// Types (derived from schemas)
export type IUser = z.infer<typeof userSchema>;
export type ILoggedUser = z.infer<typeof loggedUserSchema>;
export type IUserWithLanguage = IUser & { language: Languages };
